module.exports = __webpack_public_path__ + "static/media/front.e617feff.jpg";